import RegisterBox from "./FrontRegBox";
import { useState } from "react";
import AddMember from "./AddMember";
import EventHeader from "../Common/EventHeader";
import { useReactiveVar, useLazyQuery, useQuery } from "@apollo/client";
import { regDomainVar } from "../../RactiveVariables";
import { LIST_ALL_SCHOOL, SCHOOL_DETAILS } from "../../Graphql/queries";
export default function Regsiter(props) {
  const domainVar = useReactiveVar(regDomainVar);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [addUserOpen, setAddUserOpen] = useState(false);
  const [website, setWebsite] = useState(null);
  const { data: schoolList } = useQuery(LIST_ALL_SCHOOL,{
    variables:{
      allSch:true,
    }
  });
  const [getSchoolDetails] = useLazyQuery(SCHOOL_DETAILS, {
    onCompleted: (data) => {
      const socialMediaWeb = data?.schoolDetails?.socialMediaWeb;
      if (socialMediaWeb && socialMediaWeb.length > 0) {
        const websiteEntry = socialMediaWeb.find(item => item.title === "Website");
        if (websiteEntry) {
          setWebsite(websiteEntry.url);
        }
      }
    }
  });

  function getWebsite(id) {
    if (id) {
      getSchoolDetails({ variables: { id } });
    }
  }

  return (
    <div>
      <EventHeader EventRegistration2 setAddUserOpen={setAddUserOpen} addUserOpen={addUserOpen} title={domainVar?.schName ? `Register with ${domainVar?.schName}`:"Register"} />
      <div className="register-outer">
        {!addUserOpen && (
          <RegisterBox
          schoolList={schoolList}
            selectedSchool={selectedSchool}
            setSelectedSchool={(schoolId) => {
              setSelectedSchool(schoolId);
              getWebsite(schoolId);
            }}
            setAddUserOpen={setAddUserOpen}
          />
        )}
        {addUserOpen && (
          <AddMember EventRegistration2
            schoolId={selectedSchool}
            setAddUserOpen={setAddUserOpen}
            website={website}
          />
        )}
      </div>
    </div>
  );
}
